"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRenderable = exports.getPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var getPropType = function getPropType(_ref) {
  var propTypes = _ref.propTypes,
      defaultProps = _ref.defaultProps;
  return (0, _createChainablePropType.default)(_propTypes.default.elementType, 'renderProp', {
    propTypes: propTypes,
    defaultProps: defaultProps
  });
};

exports.getPropType = getPropType;

var isRenderable = function isRenderable(children) {
  return children != null && children !== false;
};

exports.isRenderable = isRenderable;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/utils/propTypes/renderProp.js
// module id = 55
// module chunks = 209 210 211 212